import { Box } from '@mui/material'
import { BatchParameterTable } from '../Tables/BatchParameter.MUITable'
import {
  useSettingsTableData,
  useUpdateTableData,
  useUploadParameters,
} from './TabsDataIn.data'
import { BatchParametersDataType } from '../Tables/Tables.types'
import { useRef, useState } from 'react'
import { GridRowId } from '@mui/x-data-grid-premium'
import { SaveParameters } from './SaveParameters.view'
import { useIsReadOnly } from 'Common/Hooks/useIsReadOnly.hooks'
import toast from 'react-hot-toast'
import { useRunPlan } from 'Features/EditSettings/EditSettings.data'
import { useNavigate } from 'react-router-dom'
import { RunPlanParameters } from 'Features/EditSettings/EditSettings.types'

export const BatchParametersTab = ({ planId }: TabProps) => {
  const navigate = useNavigate()
  const updatedDataRef = useRef<Record<GridRowId, BatchParametersDataType>>({})
  const [isUpdatePending, setIsUpdatePending] = useState(false)
  const parameterName = 'batch-parameters'
  const { data, isLoading } = useSettingsTableData(planId, parameterName)
  const { readOnly } = useIsReadOnly(planId)
  const onSuccess = () => {
    toast.success('Parameters updated successfully.')
  }
  const onError = () => {
    toast.error('Failed to update parameters.')
  }
  const { mutate: updateBatchParameters, isLoading: isUpdating } =
    useUpdateTableData(onSuccess, onError)

  const onUploadParametersSuccess = () => {
    toast.success('Parameters uploaded successfully.')
  }
  const onUploadParametersError = () => {
    toast.error('Failed to upload parameters.')
  }
  const { mutate: uploadParameters, isLoading: isUploading } =
    useUploadParameters(onUploadParametersSuccess, onUploadParametersError)

  const updateTableData = (
    data: Record<GridRowId, BatchParametersDataType>
  ) => {
    updatedDataRef.current = { ...updatedDataRef.current, ...data }
    if (Object.keys(updatedDataRef.current).length > 0) {
      setIsUpdatePending(true)
    }
    console.log('Updated data:', updatedDataRef.current)
  }

  const updateParametersData = (file: File) => {
    uploadParameters({
      file,
      table: parameterName,
      planId,
    })
  }

  const handleUpdate = () => {
    updateBatchParameters({
      planId,
      table: parameterName,
      data: Object.values(updatedDataRef.current),
    })
  }

  const onPlanRunInitiatedSuccess = () => {
    navigate('/')
  }

  const onPlanRunInitiatedError = (message: string) => {
    toast.error(message)
  }

  const { mutate: run, isLoading: isRunning } = useRunPlan(
    onPlanRunInitiatedSuccess,
    onPlanRunInitiatedError
  )

  const [runPlanParams, setRunPlanParams] = useState<RunPlanParameters>({
    extractData: false,
    unconstrainedPlan: true,
  })

  const handleRunPlan = () => {
    setRunPlanParams({
      ...runPlanParams,
      unconstrainedPlan: true,
    })

    run({
      planId: planId,
      parameters: runPlanParams,
    })
  }

  return (
    <Box padding={0} marginTop={2}>
      <BatchParameterTable
        data={data ?? []}
        isLoading={isLoading}
        updateTableData={updateTableData}
        updateParametersData={updateParametersData}
        isUploading={isUploading}
      />
      <SaveParameters
        handleUpdate={handleUpdate}
        isDisabled={
          isLoading || readOnly || !isUpdatePending || isUpdating || isRunning
        }
        isRunning={isLoading || isUpdating || isRunning}
        handleRunPlan={handleRunPlan}
      />
    </Box>
  )
}
